import {Header} from '~/ViewInvitation/common/RSVPModalVariantAB/steps/components/Step/components/Header/Header';
import {Button} from '~library/atoms/Button';
import {Typography} from '~library/atoms/Typography';
import {Step} from '~/ViewInvitation/common/RSVPModalVariantAB/steps/components/Step/Step';

import './RSVPConfirmed.sass';

type RSVPConfirmed = {
  isFuneral?: boolean;
  onCloseClick: () => void;
};

export const RSVPConfirmed = ({onCloseClick, isFuneral}: RSVPConfirmed) => (
  <Step
    header={<Header onClose={onCloseClick} />}
    footer={
      <Button
        variant="primary"
        size="large"
        data-qa-id="af-rsvp-view-invitation"
        onClick={onCloseClick}
        className="rsvp-step__footer__cta"
      >
        View Invitation
      </Button>
    }
    contentClassName="rsvp-confirmed"
  >
    <img
      className="rsvp-confirmed__image"
      src={
        isFuneral
          ? 'https://g0.evitecdn.com/invitation/candles.gif'
          : 'https://g0.evitecdn.com/invitation/confetti-hands.png'
      }
      alt=""
    />

    <Typography color="charcoal" variant="header3">
      Your RSVP is confirmed.
    </Typography>
  </Step>
);
